import React, {Component} from "react";
import {
    defaultTableChange,
    defaultTableChange1,
} from "../../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import Button from "../../../../../modules/commons/Button";
import * as R from "ramda";
import M from "moment/moment";
import {extractFilter, getTableConfig} from "../config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import CRMAssignModifying from "./crmAssignModifying";
import CRMAssignFilter from "./crmAssignFilter";
import CRMListUser from "./crmListUser";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import {formGroup} from "../../config";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";

class CRMAssignContent extends Component {
    headerCheckBox = [
        {
            name: "prospectId",
            label: " ",
            options: {
                customHeadRender: (props) => {
                    let checked = this.state.allSelected;
                    return (
                        <th className="checkbox-all">
                            <FlexView vAlignContent="center" style={{justifyContent: "center"}}>
                                <p>{props.label}</p>
                                <SimpleCheckBox
                                    id="check_box_all"
                                    checked={checked}
                                    onChange={this.handleCheckAll}
                                />
                            </FlexView>
                        </th>
                    )
                },
                customBodyRender: (val, {rowIndex, rowData}) => {
                    let checked = this.checkListSelectedId(val);
                    return (
                        <FlexView style={{justifyContent: "center"}}>
                            <SimpleCheckBox
                                id={`check_box_${rowIndex}`}
                                onChange={() => this.handleOnRowSelected(val)}
                                checked={checked}
                            />
                        </FlexView>
                    )
                },
            }
        },
    ];

    actionsButton = [
        {
            name: "prospectId",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    return (
                        <SimpleButton
                            category="action_button"
                            className="btnAct"
                            onClick={() =>
                                this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, val)
                            }
                            icon={
                                <i
                                    className="fa fa-lw fa-eye"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            }
                        />
                    );
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            employeeId: null,
            filterVisible: false,
            modifyingVisible: false,
            userVisible: false,
            selectedData: null,
            tableColumn: [],
            selectedDataAssign: [],
            allSelected: false,
            activityType: null,
            dataTable: [],
            submittedFilter: {},
            listUser: [],
            confirmReassignToCRM: false,
            confirmReassignTo: false,
            search: {
                kodeCabang: {},
                startDate: M(Date.now()).format("DD-MM-YYYY"),
                endDate: M(Date.now()).format("DD-MM-YYYY"),
            },
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
            },
            alertInfo: {
                visible: false,
                title: null,
                content: null,
            }
        };
    }

    componentDidMount = async () => {
        await this.setState((prevValue) => ({
            ...prevValue,
            tableColumn: [
                ...this.headerCheckBox,
                ...getTableConfig(this.props.tab),
                ...this.actionsButton],
            pagination: {
                ...prevValue.pagination,
                totalData: 1,
            },
            search: {
                ...prevValue.search,
                kodeCabang: this.props.state.kodeCabang,
            },
        }));
        if (!R.isEmpty(this.props.state.kodeCabang)) {
            await this.fetchData();
        }
    };

    async componentDidUpdate(prevProps) {
        if (prevProps.state.kodeCabang.value !== this.props.state.kodeCabang.value) {
            this.handleRefresh()
        }
    }

    buildRequestBody = () => {
       const { search, submittedFilter, pagination } = this.state;

       const usedFilter = !R.isEmpty(submittedFilter)
          ? submittedFilter
          : search;

       return {
          ...removeNullFields(extractFilter(usedFilter)),
          kodeCabang: search.kodeCabang.value,
          tab: this.props.tab,
          page: pagination.page,
          limit: pagination.limit,
       };
    };


    handleRefresh = () => {
        this.setState(
            (prevValue) => ({
                ...prevValue,
                search: {
                    ...prevValue.search,
                    kodeCabang: this.props.state.kodeCabang,
                    startDate: M().format("DD-MM-YYYY"),
                    endDate: M().format("DD-MM-YYYY"),
                },
                submittedFilter: {},
            }),
            () => {
                this.fetchData();
            }
        );
    };

    fetchData = async (filter) => {
        this.props.handleLoading();

        let usedFilter = !R.isNil(filter)
            ? {
                ...filter,
                kodeCabang: filter.kodeCabang || this.state.search.kodeCabang.value,
            }
            : {
                ...this.state.search,
                kodeCabang: this.state.search.kodeCabang.value,
            };

        if (!R.isNil(filter)) {
            this.setState((prev) => ({
                ...prev,
                submittedFilter: filter,
            }));
        }

        let filteredRequest = extractFilter(usedFilter);

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataTabAssignProspect,
            menuName: "CRM - Assign Prospek",
            setError: this.props.setError,
            args: {
               ...removeNullFields(filteredRequest),
               tab: this.props.tab,
               page: this.state.pagination.page,
               limit: this.state.pagination.limit,
            },
            // args: {
            //     ...removeNullFields(filteredRequest),
            //     tab: this.props.tab,
            // },
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data || [],
                pagination: {
                    ...prevState.pagination,
                    totalData: res.data.totalData,
                },
                employeeId: null,
                selectedDataAssign: [],
                allSelected: false,
            }));
        }

        this.props.handleLoading();
    };

    handleOnRowSelected = (prospectId) => {
        let {selectedDataAssign, dataTable} = this.state;
        let allSelected = false;
        if (selectedDataAssign.includes(prospectId)) {
            selectedDataAssign = selectedDataAssign.filter(i => i !== prospectId);
        } else {
            selectedDataAssign = [...selectedDataAssign, prospectId];
        }
        if (selectedDataAssign.length === dataTable.length) {
            allSelected = true;
        }
        this.setState((prevState) => ({
            ...prevState,
            selectedDataAssign,
            allSelected,
        }));
    };

    checkListSelectedId = (prospectId) => {
        let {selectedDataAssign} = this.state;
        return selectedDataAssign.includes(prospectId);
    };

    handleCheckAll = () => {
        let {allSelected, dataTable} = this.state;
        if (R.isEmpty(dataTable)) {
            return;
        }
        let listProspectId = [];
        if (!allSelected) {
            listProspectId = dataTable.map(i => i.prospectId);
        }
        this.setState((prevState) => ({
            ...prevState,
            allSelected: !allSelected,
            selectedDataAssign: listProspectId,
        }))
    };

    handlePeriodChange = (name, value) => {
        if (
            R.equals(name, "endDate") &&
            M(value).isBefore(this.state.search.startDate)
        ) {
            this.setState((prevValue) => ({
                ...prevValue,
                search: {
                    ...prevValue.search,
                    startDate: M(value).format("DD-MM-yyyy"),
                    endDate: M(value).format("DD-MM-yyyy"),
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: M(value).format("DD-MM-yyyy"),
            },
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleAlertInfoVisibility = (title = null, content = null) => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertInfo: {
                visible: !prevValue.alertInfo.visible,
                title: title,
                content: content,
            },
        }));
    }

    handleUserVisibility = async () => {
        if (!this.state.userVisible) {
            this.props.handleLoading();
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getEmployeeForCRM,
                menuName: "CRM - Assign Prospek",
                setError: this.props.setError,
                args: this.props.state.kodeCabang.value,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    listUser: res.data.data,
                }));
            }
            this.props.handleLoading();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            userVisible: !prevValue.userVisible,
        }));
    };

    handleModifyingVisibility = async (at, id) => {
        this.props.handleLoading();
        if (id) {
            let res = await Api.create("NAGAMAS_TRANSACTION").getDetailProspect(id);
            if (res.ok) {
                if (res.data.status === HttpStatus.FAILED) {
                    this.props.setError({
                        menuName: "CRM - Assign Prospek",
                        errorMessage: res.data.message,
                    });
                } else {
                    let data = res.data.data;
                    let selectedData = {
                        ...data.dataKTP,
                        provinceId: mapToObjectDDL(
                            data.dataKTP.dataProvince.provinceName,
                            data.dataKTP.dataProvince.id
                        ),
                        kabkotId: mapToObjectDDL(
                            data.dataKTP.dataKabKot.kabKotName,
                            data.dataKTP.dataKabKot.kabKotId
                        ),
                        kecamatanId: mapToObjectDDL(
                            data.dataKTP.dataKecamatan.kecamatanName,
                            data.dataKTP.dataKecamatan.id
                        ),
                        kelurahanId: mapToObjectDDL(
                            data.dataKTP.dataKelurahan.kelurahanname,
                            data.dataKTP.dataKelurahan.id
                        ),
                        zipcode: mapToObjectDDL(data.dataKTP.zipcode, data.dataKTP.zipcode),
                        gender: mapToObjectDDL(
                            data.dataKTP.gender?.value,
                            data.dataKTP.gender?.key
                        ),
                        religion: mapToObjectDDL(
                            data.dataKTP.religion.value,
                            data.dataKTP.religion.key
                        ),
                        job1: mapToObjectDDL(
                            data.dataKTP.job1.value,
                            data.dataKTP.job1.key
                        ),
                        job2: R.isNil(data.dataKTP.job2)
                            ? null
                            : mapToObjectDDL(data.dataKTP.job2.value, data.dataKTP.job2.key),
                        ...data.dataTambahan,
                        hobby: data.dataTambahan.hobby.map((item) =>
                            mapToObjectDDL(item.value, item.key)
                        ),
                        interest: data.dataTambahan.interest.map((item) =>
                            mapToObjectDDL(item.value, item.key)
                        ),
                        ...data.dataMember,
                        memberLevel: mapToObjectDDL(
                            data.dataMember.memberLevel,
                            data.dataMember.memberLevel
                        ),
                        loyaltyLevel: mapToObjectDDL(
                            data.dataMember.loyaltyMember,
                            data.dataMember.loyaltyMember
                        ),
                        ...data.dataSistem,
                        category: mapToObjectDDL(
                            data.dataSistem.category,
                            data.dataSistem.category
                        ),
                        source: mapToObjectDDL(
                            data.dataSistem.source,
                            data.dataSistem.source
                        ),
                        type: mapToObjectDDL(data.dataSistem.type, data.dataSistem.type),
                    };
                    this.setState((prevValue) => ({
                        ...prevValue,
                        activityType: at,
                        selectedData: selectedData,
                        modifyingVisible: !prevValue.modifyingVisible,
                    }));
                }
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                activityType: at,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.props.handleLoading();
    };

    handleSubmitFilter = async (filter, resetFilter) => {
        this.handleRefreshPagination()
        this.handleFilterVisibility();
        await this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                startDate: resetFilter ? M(Date.now()).format("DD-MM-YYYY") : null,
                endDate: resetFilter ? M(Date.now()).format("DD-MM-YYYY") : null,
            },
            pagination: {
                ...prevValue.pagination,
                page: 1,
                limit: 5,
            },
        }));
        await this.fetchData(resetFilter ? null : filter);
    };

    handleSetState = (callback) => {
        this.setState(callback);
    };

    handleAssignTo = async () => {
        if (this.state.confirmReassignTo) this.confirmReassignTo();
        this.props.handleLoading();

        if (!R.isEmpty(this.state.selectedDataAssign)) {

            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").assignProspect,
                menuName: "CRM - Assign Prospek",
                setError: this.props.setError,
                args: {
                    employeeId: this.state.employeeId,
                    prospectIds: this.state.selectedDataAssign,
                },
            });

            if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {

                this.setState((prevValue) => ({
                    ...prevValue,
                    allSelected: false,
                    selectedDataAssign: [],
                }));

                this.handleUserVisibility();
                await this.fetchData(this.buildRequestBody());
            }

            const message = res?.data?.message || "";
            if (message?.startsWith("Pengajuan tidak dapat dilakukan ")) {
                this.handleAlertInfoVisibility(
                    "Informasi",
                    res?.data?.message || "Terjadi Kesalahan pada server"
                );
            }
        }

        if (this.state.confirmReassignTo) {
            this.confirmReassignTo();
        }

        this.props.handleLoading();
    };


    confirmReassignToCRM = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            confirmReassignToCRM: !prevValue.confirmReassignToCRM,
        }));
    };

    confirmReassignTo = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            confirmReassignTo: !prevValue.confirmReassignTo,
        }));
    };

    handleAssignToCRM = async () => {
        if (this.state.confirmReassignToCRM) this.confirmReassignToCRM();
        this.props.handleLoading();

        if (!R.isEmpty(this.state.selectedDataAssign)) {

            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").assignProspect,
                menuName: "CRM - Assign Prospek",
                setError: this.props.setError,
                args: {
                    crm: true,
                    prospectIds: this.state.selectedDataAssign,
                },
            });

            if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {

                this.setState((prevValue) => ({
                    ...prevValue,
                    allSelected: false,
                    selectedDataAssign: [],
                }));
                await this.fetchData(this.buildRequestBody());
            }

            const message = res?.data?.message || "";
            if (message?.startsWith("Pengajuan tidak dapat dilakukan ")) {
                this.handleAlertInfoVisibility(
                    "Informasi",
                    res?.data?.message || "Terjadi Kesalahan pada server"
                );
            }
        }

        this.props.handleLoading();
    };


    handleClickAssignToCRM = () => {
        if (this.props.tab === "assigned") {
            this.confirmReassignToCRM();
        } else {
            this.handleAssignToCRM();
        }
    };

    handleClickAssignTo = async (user) => {
        await this.setState((prevValue) => ({
            ...prevValue,
            employeeId: user,
        }));
        if (this.props.tab === "assigned") {
            this.confirmReassignTo();
        } else {
            this.handleAssignTo();
        }
    };

    handleRefreshPagination = () => {
        this.setState((prevState) => ({
            ...prevState,
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
            },
        }));
    }

    handleTableChange = (action, tableState) => {
        if (action === "changePage") {
            this.setState(
                (prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        page: tableState.page + 1,
                    },
                }),
                () => {
                    this.fetchData(this.buildRequestBody());
                }
            );
        }
    
        if (action === "changeRowsPerPage") {
            this.setState(
                (prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        page: 1,
                        limit: tableState.rowsPerPage,
                    },
                }),
                () => {
                    this.fetchData(this.buildRequestBody());
                }
            );
        }
    };


    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    vAlignContent="center"
                    className="margin-top-5px"
                >
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p className="margin-bottom-20px">Periode: </p>
                        <SimpleDate
                            id="select_prospek_date_period_from"
                            name="startDate"
                            nextdate
                            date={this.state.search.startDate}
                            maxDate={this.state.search.endDate}
                            onChange={(value) => this.handlePeriodChange("startDate", value)}
                        />
                        <span className="margin-bottom-20px">s/d</span>
                        <SimpleDate
                            id="select_prospek_date_period_to"
                            name="endDate"
                            nextdate
                            date={this.state.search.endDate}
                            minDate={this.state.search.startDate}
                            onChange={(value) => this.handlePeriodChange("endDate", value)}
                        />
                        <SimpleButton
                            className="margin-bottom-20px"
                            onClick={() => this.fetchData(this.state.search)}
                        >
                            Cari
                        </SimpleButton>
                    </FlexView>
                    <Button
                        type="button"
                        onClick={this.handleFilterVisibility}
                        className="btn background-red margin-bottom-20px"
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                <SimpleDataTable
                    key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                    data={this.state.dataTable}
                    columns={this.state.tableColumn}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{
                        serverSide: true,
                        onTableChange: this.handleTableChange,
                    }}
                />
                <FlexView style={{justifyContent: "end", marginTop: "20px"}}>
                    <SimpleButton onClick={this.handleClickAssignToCRM}>
                        {this.props.tab === "assigned" ? "Rea" : "A"}ssign To CRM
                    </SimpleButton>
                    <SimpleButton onClick={this.handleUserVisibility}>
                        {this.props.tab === "assigned" ? "Rea" : "A"}ssign To
                    </SimpleButton>
                </FlexView>
                {this.state.filterVisible && (
                    <CRMAssignFilter
                        search={this.state.submittedFilter}
                        visible={this.state.filterVisible}
                        onClickClose={this.handleFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                        onSetState={this.handleSetState}
                    />
                )}
                {this.state.modifyingVisible && (
                    <CRMAssignModifying
                        formGroup={formGroup}
                        tab={this.props.tab}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingVisibility}
                        activityType={this.state.activityType}
                    />
                )}
                {this.state.userVisible && (
                    <CRMListUser
                        {...this.props}
                        listUser={this.state.listUser}
                        visible={this.state.userVisible}
                        onClickClose={this.handleUserVisibility}
                        onSelectUser={this.handleClickAssignTo}
                    />
                )}
                {this.state.confirmReassignToCRM && (
                    <SimpleAlert
                        visible={this.state.confirmReassignToCRM}
                        onClickClose={this.confirmReassignToCRM}
                        content={
                            <div>
                                <p>Anda memindahkan Assignment prospek</p>
                                <p>
                                    kepada <b>PETUGAS CRM.</b> Proses ini akan
                                </p>
                                <p>diteruskan kepada proses approval.</p>
                                <p>Apakah anda yakin?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={this.confirmReassignToCRM}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={this.handleAssignToCRM}>
                                    Iya
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.confirmReassignTo && (
                    <SimpleAlert
                        visible={this.state.confirmReassignTo}
                        onClickClose={this.confirmReassignTo}
                        content={
                            <div>
                                <p>Anda memindahkan Assignment prospek</p>
                                <p>kepada User lain. Proses ini akan</p>
                                <p>diteruskan kepada proses approval.</p>
                                <p>Apakah anda yakin?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={this.confirmReassignTo}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={this.handleAssignTo}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}

                {this.state.alertInfo?.visible && (
                  <SimpleAlert
                    title={this.state.alertInfo?.title}
                    content={<p>{this.state.alertInfo?.content}</p>}
                    visible={this.state.alertInfo?.visible}
                    onClickClose={()=>this.handleAlertInfoVisibility()}
                    additionalButtons={
                      <SimpleButton
                        type="button"
                        text="OK"
                        onClick={() => this.handleAlertInfoVisibility()}
                      />
                    }
                  />
                )}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(CRMAssignContent);
